import httpClientImmigration from "@/services/httpClientImmigration";
import { server } from "@/services/constants";

export const getWorkPlaceofissue = () => {
  return httpClientImmigration.get(server.IM_MASTER_WORK_PLACE_OF_ISSUE);
};

export const getImMasterWorkPlaceofissueByCompany = (query) => {
  return httpClientImmigration.get(
    server.IM_MASTER_WORK_PLACE_OF_ISSUE + `/getbycompany`,
    query,
  );
};

export const getImMasterWorkPlaceofissueByDep = (dep_id) => {
  return httpClientImmigration.get(
    server.IM_MASTER_WORK_PLACE_OF_ISSUE + `/get-by-dep_id/${dep_id}`,
  );
};

export const getImMasterWorkPlaceofissueByID = (id) => {
  return httpClientImmigration.get(
    server.IM_MASTER_WORK_PLACE_OF_ISSUE + `/get-by-id/${id}`,
  );
};

export const addImMasterWorkPlaceofissue = (data) => {
  return httpClientImmigration.post(server.IM_MASTER_WORK_PLACE_OF_ISSUE, data);
};

export const UpdateImMasterWorkPlaceofissue = (id, data) => {
  return httpClientImmigration.put(
    server.IM_MASTER_WORK_PLACE_OF_ISSUE + `/${id}`,
    data,
  );
};

export const DeleteImMasterWorkPlaceofissue = (id) => {
  return httpClientImmigration.delete(
    server.IM_MASTER_WORK_PLACE_OF_ISSUE + `/${id}`,
  );
};

export const getImMasterWorkPlaceofissueByCompany_Dep = (query) => {
  return httpClientImmigration.get(
    server.IM_MASTER_WORK_PLACE_OF_ISSUE + `/getbycompanyanddepartment`,
    query,
  );
};

export const getImMasterWorkPlaceofissueByCompany_Dep_Pagination = (
  page,
  limit,
  sortBy,
  sortOrder,
  company_id,
  department_id,
  search,
) => {
  return httpClientImmigration.get(
    server.IM_MASTER_WORK_PLACE_OF_ISSUE +
      `/getbycompanyanddepartmentpagination`,
    {
      params: {
        page: page,
        limit: limit,
        sortBy: sortBy,
        sortOrder: sortOrder,
        company_id: company_id,
        department_id: department_id,
        search: search,
      },
    },
  );
};
